import React from 'react';
import { Alert, Button } from 'antd';
import { useTranslate } from '@/translations';
import { useComms } from '@/modules/comms/context/CommsContext';

export const CommandCentreCommsBootstrap = () => {
  const { t } = useTranslate();
  const { status, retryStart } = useComms();

  if (status === 'failed')
    return (
      <Alert
        role="alert"
        type="error"
        showIcon
        message={t('commsConnectionFailed')}
        action={
          <Button size="small" onClick={() => void retryStart()}>
            {t('commsRetryConnection')}
          </Button>
        }
      />
    );

  if (status === 'starting' || status === 'reconnecting')
    return (
      <span role="status" className="small text-muted">
        {t(status === 'reconnecting' ? 'commsReconnecting' : 'commsConnecting')}
      </span>
    );

  return null;
};
